module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "resume-list-template"
    }
  }, [_c('div', {
    staticClass: "job-search-condition-board"
  }, [_c('div', {
    staticClass: "sub-text"
  }, [_vm._v(_vm._s(_vm.member.name) + "님은")]), _vm._v(" "), _c('div', {
    staticClass: "main-text-wrap"
  }, [_c('span', {
    staticClass: "text"
  }, [(_vm.jobSearchStatusLabel) ? [_vm._v("\n          현재 "), _c('strong', [_vm._v("\"" + _vm._s(_vm.jobSearchStatusLabel) + "\"")]), _vm._v(" 상태입니다.\n        ")] : [_vm._v("\n          구직상태를 선택해 주세요.\n        ")]], 2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-gray btn-xsm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showJobSearchStatusModal
    }
  }, [_vm._v("\n        구직상태 변경하기\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "job-keyword-wrap"
  }, [_c('div', {
    staticClass: "job-keyword"
  }, [_c('span', [_vm._v("주된 직업군")]), _vm._v(" " + _vm._s(_vm.member.occuPation))]), _vm._v(" "), _c('div', {
    staticClass: "job-keyword"
  }, [_c('span', [_vm._v("주소지")]), _vm._v(" " + _vm._s(_vm.district))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "resume-list-header"
  }, [_c('h3', [_vm._v("나의 이력서 목록")]), _vm._v(" "), _c('p', {
    staticClass: "resume-count"
  }, [_vm._v("총 " + _vm._s(_vm.activeCount) + "건의 작성된 이력서가 있습니다.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-line-box btn-sm btn-updata",
    on: {
      "click": _vm.updateAllToday
    }
  }, [_c('i', {
    staticClass: "ico ico-refresh"
  }), _vm._v("\n        오늘 날짜로 업데이트\n      ")])]), _vm._v(" "), _c('section', {
    staticClass: "resume-list-section"
  }, [_vm._l((_vm.resumeList), function(resume, index) {
    return _c('div', {
      key: resume.indbankNo,
      staticClass: "resume-card"
    }, [_c('div', {
      staticClass: "resume-card-header"
    }, [_c('div', {
      staticClass: "last-updata-text"
    }, [_vm._v("최근 업데이트 : " + _vm._s(resume.formattedChgDate))]), _vm._v(" "), _c('div', {
      staticClass: "resume-card-body-top"
    }, [_c('h4', {
      staticClass: "resume-title"
    }, [_vm._v(_vm._s(resume.title))]), _vm._v(" "), _c('div', {
      staticClass: "resume-controls"
    }, [_c('div', {
      staticClass: "representative-switch"
    }, [_c('label', {
      staticClass: "switch-container"
    }, [_c('input', {
      staticClass: "switch-input",
      attrs: {
        "type": "radio",
        "id": "switch1",
        "name": "representative-resume",
        "disabled": _vm.resumeList.length === 1,
        "title": "switch1 선택"
      },
      domProps: {
        "checked": resume.mainYn === 'Y'
      },
      on: {
        "change": function($event) {
          return _vm.changeMainResume(resume.indbankNo)
        }
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v("\n                대표\n              ")]), _vm._v(" "), _c('div', {
      ref: ("moreList" + (resume.indbankNo)),
      refInFor: true,
      staticClass: "more-list"
    }, [_c('button', {
      staticClass: "btn btn-only-icon btn-more",
      attrs: {
        "aria-label": "더보기",
        "title": "더보기"
      },
      on: {
        "click": function($event) {
          return _vm.toggleMoreList(resume.indbankNo, $event)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-h-dot"
    })]), _vm._v(" "), _c('ul', {
      staticClass: "more-list-detail",
      class: {
        'show': _vm.showMoreList === resume.indbankNo
      }
    }, [_c('li', {
      staticClass: "btn btn-line-box btn-sm cpy",
      staticStyle: {
        "display": "inline-grid",
        "height": "66px"
      }
    }, [_c('button', {
      on: {
        "click": function($event) {
          return _vm.copyResume(resume)
        }
      }
    }, [_vm._v("복사하기")]), _vm._v(" "), _c('button', {
      attrs: {
        "disabled": resume.mainYn === 'Y'
      },
      on: {
        "click": function($event) {
          return _vm.delResume(resume)
        }
      }
    }, [_vm._v("삭제하기")])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "resume-card-body"
    }, [_c('div', {
      staticClass: "resume-card-body-main"
    }, [_c('div', {
      staticClass: "progress-section"
    }, [_c('div', {
      staticClass: "progress-data"
    }, [_c('div', {
      staticClass: "progress-text"
    }, [_vm._v("\n                  완성도\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "progress-bar-container"
    }, [_c('div', {
      staticClass: "progress-bar",
      style: (_vm.getProgressWidth(resume.completionRate))
    })]), _vm._v(" "), _c('div', {
      staticClass: "percentage"
    }, [_vm._v(_vm._s(Math.round(resume.completionRate * 100)) + "%")])]), _vm._v(" "), _c('div', {
      staticClass: "progress-subtext"
    }, [_vm._v("(높은 이력서 완성도는 더 많은 맞춤형 일자리 추천을 받으실 수 있습니다.)")])]), _vm._v(" "), _c('div', {
      staticClass: "keywords-section"
    }, [_c('p', {
      staticClass: "keywords-title"
    }, [_vm._v("이력서 키워드")]), _vm._v(" "), _c('div', {
      staticClass: "keywords-tag-list"
    }, _vm._l((resume.keywords), function(keyword, index) {
      return _c('button', {
        key: index,
        staticClass: "keyword-tag",
        attrs: {
          "type": "button"
        }
      }, [_vm._v(_vm._s(keyword))])
    }), 0)])])]), _vm._v(" "), _c('div', {
      staticClass: "resume-card-footer"
    }, [_c('button', {
      staticClass: "btn btn-secondary btn-md",
      on: {
        "click": function($event) {
          return _vm.showPreview(resume.indbankNo)
        }
      }
    }, [_vm._v("미리보기")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-secondary btn-md",
      on: {
        "click": function($event) {
          return _vm.printResume(resume.indbankNo)
        }
      }
    }, [_vm._v("출력")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary btn-md",
      on: {
        "click": function($event) {
          return _vm.modify(resume.indbankNo)
        }
      }
    }, [_c('i', {
      staticClass: "ico ico-pen-wt"
    }), _vm._v("\n            수정하기\n          ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-direction align-items-center"
  }, [_c('button', {
    staticClass: "add-resume-icon",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addResume
    }
  }, [_c('i', {
    staticClass: "ico ico-plus48"
  }), _vm._v(" "), _c('p', [_vm._v("이력서 추가하기")])]), _vm._v(" "), _c('p', [_vm._v("이력서는 최대 3개까지 작성하실 수 있습니다.")])])], 2), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('job-search-status-modal', {
    attrs: {
      "jobSearchStatusModal": _vm.jobSearchStatusModal,
      "jobSearchStatus": _vm.member.jobSearchStatus
    },
    on: {
      "update:jobSearchStatus": _vm.closeJobSearchStatusModal
    }
  }), _vm._v(" "), _c('preview-modal', {
    attrs: {
      "previewModal": _vm.previewModal,
      "indbankNo": _vm.selectedResume.indbankNo
    },
    on: {
      "closePreviewModal": _vm.closePreview,
      "openDetail": _vm.modify
    }
  }), _vm._v(" "), _c('detail-modal', {
    attrs: {
      "detailModal": _vm.detailModal,
      "resume": _vm.selectedResume,
      "district": _vm.district
    },
    on: {
      "closeDetailviewModal": _vm.closeDetailview,
      "update:resumeList": _vm.getResumeList
    }
  }), _vm._v(" "), _c('introduction-ex-one-modal'), _vm._v(" "), _c('introduction-ex-twe-modal')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-type bg-primary type-left mt-24"
  }, [_c('ul', {
    staticClass: "list-type-dot"
  }, [_c('li', [_vm._v("구직상태가 “구직 희망 중” 또는 “이직 고려 중”일 경우 일자리 몽땅에서 제공하는 일자리 추천을 받으실 수 있습니다.")]), _vm._v(" "), _c('li', {
    staticClass: "mt-16"
  }, [_vm._v("“주된 직업 군”과 “거주지(주소지)”는 일자리 추천 시 활용되는 정보이므로 맞춤 일자리 추천을 위해 정확히 입력해 주세요.\n        "), _c('a', {
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "href": "/mypage-info.do"
    }
  }, [_vm._v("회원정보 수정")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-bg"
  }, [_c('div', {
    staticClass: "switch-handle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-type bg-primary type-left mt-40"
  }, [_c('ul', {
    staticClass: "list-type-dot"
  }, [_c('li', [_vm._v("이력서 등록은 최대 3개까지 가능하며, 지원 시 이력서를 선택하여 지원하실 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("대표이력서로 선택된 이력서는 지원 시 자동으로 선택되며, 지원 시 다른 이력서를 선택하여 지원하실 수 있습니다.")]), _vm._v(" "), _c('li', [_vm._v("‘오늘날짜로 업데이트’버튼을 눌러 작성한 모든 이력서의 최근 업데이트일을 오늘 날짜로 변경하실 수 있습니다.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6029199c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/resume/resumeList.vue
// module id = 1422
// module chunks = 6